import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';

/**
 * 登录弹窗 GA 埋点 - 保存触发登录弹窗的页面路径
 */
export function logLoginModelGA() {
  const pathname = window.location.pathname;
  ga_logEvent(EventName.login_shown, { page_source: pathname });
}

/**
 * 注册弹框 GA 埋点 - 保存触发注册弹窗的页面路径
 */
export function logRegisterModelGA() {
  const pathname = window.location.pathname;
  ga_logEvent(EventName.signup_shown, { page_source: pathname });
}
